'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../../../util');

var _util2 = _interopRequireDefault(_util);

var _icon = require('../../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _lodashCompat = require('lodash-compat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * 搜索条件展示区
 */

var SearchCondition = function (_M$BaseComponent$Mixi) {
  _inherits(SearchCondition, _M$BaseComponent$Mixi);

  function SearchCondition() {
    _classCallCheck(this, SearchCondition);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(SearchCondition).apply(this, arguments));
  }

  _createClass(SearchCondition, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var baseCls = this.props.className;
      var records = this.context.records;

      var condition = records._getCondition();
      var searchFields = records._getSearchFieldsMap();
      return _react2.default.createElement(
        'div',
        { className: this.classNames() },
        _react2.default.createElement(
          'ul',
          { className: baseCls + '__list' },
          condition.map(function (v, k) {
            var showContent = _this2._format(searchFields[k], v);
            return _react2.default.createElement(
              'li',
              { key: k, className: baseCls + '__list-item',
                onClick: _this2._onDelete.bind(_this2, k) },
              _react2.default.createElement(
                'span',
                { className: baseCls + '__item-text', title: showContent },
                showContent
              ),
              _react2.default.createElement(_icon2.default, { className: baseCls + '__delete-icon', type: 'close' })
            );
          }).toArray(),
          condition.size > 0 && _react2.default.createElement(
            'li',
            { key: 'clearAll', className: baseCls + '__clear-all',
              onClick: this._onDeleteAll },
            '取消筛选'
          )
        )
      );
    }
  }, {
    key: '_onDelete',
    value: function _onDelete(key) {
      var records = this.context.records;

      records._setCondition(_defineProperty({}, key, undefined));
    }
  }, {
    key: '_onDeleteAll',
    value: function _onDeleteAll() {
      var records = this.context.records;

      records.reset();
    }
  }, {
    key: '_format',
    value: function _format(field, v) {
      var format = field.conf && field.conf.format || '%Y-%m-%d';
      var content = void 0;
      switch (field.type) {
        case 'date':
          content = _util2.default.formatDatetime(v, format);
          break;
        case 'rangeDate':
          if ((0, _lodashCompat.isArray)(v)) {
            content = _util2.default.formatDatetime(v[0], format);
            content += ' ~ ';
            if (v[2]) {
              content += '至今';
            } else if (v[1]) {
              content += _util2.default.formatDatetime(v[1], format);
            }
          }
          break;
        default:
          if ((0, _lodashCompat.isArray)(v)) {
            content = (v || []).map(function (item) {
              return (0, _lodashCompat.isObject)(item) ? item.label : item;
            });
          } else {
            content = [(0, _lodashCompat.isObject)(v) ? v.label : v];
          }
          content = content.join('/');
      }
      return field.label + '：' + content;
    }
  }]);

  return SearchCondition;
}(_util2.default.BaseComponent.Mixin(_util2.default.ContextMixin('records')));

exports.default = SearchCondition;